import React from 'react';

import { Checkbox } from '@/components/ui/checkbox';
import { CommandGroup, CommandItem } from '@/components/ui/command';
import { useBoard, useFilters } from '../../../hooks';

const StatusList = () => {
  const { statuses } = useBoard();
  const { activeFilters, toggleFilter } = useFilters();

  const isSelected = (value) => activeFilters.statuses.includes(value);

  return (
    <CommandGroup>
      {statuses.map((status) => (
        <CommandItem
          key={status.id}
          onSelect={() => toggleFilter({ type: 'statuses', value: status.id })}
          value={status.name}
        >
          <Checkbox checked={isSelected(status.id)} />
          <span className="truncate">{status.name}</span>
        </CommandItem>
      ))}
    </CommandGroup>
  );
};

export default StatusList;
